import React from "react";

// Promoted out of features/stock (2026-08-29) so Petty Cash can reuse the
// same badge instead of a copy-pasted component - Stock's own
// SUBMITTED/APPROVED/... vocabulary stays the default map (every existing
// Stock caller keeps working unchanged), other modules pass their own
// classMap/labelMap to override just the statuses they use.
const DEFAULT_CLASS_BY_STATUS = {
  SUBMITTED: "badge-linewarning",
  REVISED_SUBMITTED: "badge-linewarning",
  APPROVED: "badge-linesuccess",
  PARTIALLY_RECEIVED: "badge-lineinfo",
  FULLY_RECEIVED: "badge-linesuccess",
  POSTED: "badge-linesuccess",
  ISSUED: "badge-linesuccess",
  REJECTED: "badge-linedanger",
  CANCELLED: "badge-linedanger",
};

const DEFAULT_LABEL_BY_STATUS = {
  SUBMITTED: "Submitted",
  REVISED_SUBMITTED: "Revised - Submitted",
  APPROVED: "Approved",
  PARTIALLY_RECEIVED: "Partially Received",
  FULLY_RECEIVED: "Fully Received",
  POSTED: "Posted",
  ISSUED: "Issued",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
};

const StatusBadge = ({ status, classMap, labelMap }) => {
  const classes = { ...DEFAULT_CLASS_BY_STATUS, ...classMap };
  const labels = { ...DEFAULT_LABEL_BY_STATUS, ...labelMap };
  return (
    <span className={`badge ${classes[status] || "badge-linesecondary"}`}>
      {labels[status] || status}
    </span>
  );
};

export default StatusBadge;
